import { EventEmitter, Injectable } from '@angular/core';
import { SnotifyPosition, SnotifyService, SnotifyToastConfig } from 'ng-snotify';
import { Observable } from 'rxjs';
import { getApiErrorMessage } from './api-response.util';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  title = 'blue';
  style = 'material';
  body = 'Lorem ipsum dolor sit amet!';
  timeout = 1300;
  position: SnotifyPosition = SnotifyPosition.rightBottom;
  progressBar = true;
  closeClick = true;
  newTop = true;
  filterDuplicates = false;
  backdrop = -1;
  dockMax = 8;
  blockMax = 6;
  pauseHover = true;
  titleMaxLength = 15;
  bodyMaxLength = 80;
  dataStr = new EventEmitter<any>();
  constructor(private snotifyService: SnotifyService, private sharedService: SharedService) {
  }
  getConfig(): SnotifyToastConfig {
    this.snotifyService.setDefaults({
      global: {
        newOnTop: this.newTop,
        maxAtPosition: this.blockMax,
        maxOnScreen: this.dockMax,
      }
    });
    return {
      bodyMaxLength: this.bodyMaxLength,
      titleMaxLength: this.titleMaxLength,
      backdrop: this.backdrop,
      position: this.position,
      timeout: this.timeout,
      showProgressBar: this.progressBar,
      closeOnClick: this.closeClick,
      pauseOnHover: this.pauseHover
    };
  }
  notify(type: string, title: string, body: string) {
    switch (type) {
      case 'success':
        this.onSuccess(title, body);
        break;
      case 'error':
        this.onError(title, body);
        break;
      case 'warning':
        this.onWarning(title, body);
        break;
      case 'info':
        this.onInfo(title, body);
        break;
    }
  }

  getApiErrorText(source: any, fallback: string): string {
    return getApiErrorMessage(source, fallback);
  }

  notifyApiError(title: string, source: any, fallback: string): void {
    this.notify('error', title, getApiErrorMessage(source, fallback));
  }

  notifyApiWarning(title: string, source: any, fallback: string): void {
    this.notify('warning', title, getApiErrorMessage(source, fallback));
  }
  onSuccess(title, body) {
    this.snotifyService.success(body, title, this.getConfig());
  }
  onInfo(title, body) {
    this.snotifyService.info(body, title, this.getConfig());
  }
  onError(title, body) {
    this.snotifyService.error(body, title, this.getConfig());
  }
  onWarning(title, body) {
    this.snotifyService.warning(body, title, this.getConfig());
  }
  onSimple(title, body) {
    const icon = `https://placehold.it/48x100`;
    this.snotifyService.simple(body, title, {
      ...this.getConfig(),
      icon: icon
    });
  }
  onAsyncLoading() {
    const errorAction = Observable.create(observer => {
      setTimeout(() => {
        observer.error({
          title: 'Error',
          body: 'Example. Error 404. Service not found',
        });
      }, 2000);
    });
    const successAction = Observable.create(observer => {
      setTimeout(() => {
        observer.next({
          body: 'Still loading.....',
        });
      }, 2000);
      setTimeout(() => {
        observer.next({
          title: 'Success',
          body: 'Example. Data loaded!',
          config: {
            closeOnClick: true,
            timeout: 5000,
            showProgressBar: true
          }
        });
        observer.complete();
      }, 5000);
    });
    const { timeout, ...config } = this.getConfig();
    this.snotifyService.async('This will resolve with error', 'Async', errorAction, config);
    this.snotifyService.async('This will resolve with success', successAction, config);
    this.snotifyService.async('Called with promise', 'Error async',
      new Promise((resolve, reject) => {
        setTimeout(() => reject({
          title: 'Error!!!',
          body: 'We got an example error!',
          config: {
            closeOnClick: true
          }
        }), 1000);
        setTimeout(() => resolve(), 1500);
      }), config);
  }
  onConfirmation() {
    const { timeout, closeOnClick, ...config } = this.getConfig();
    this.snotifyService.confirm(this.body, this.title, {
      ...config,
      buttons: [
        { text: 'Yes', action: () => console.log('Clicked: Yes'), bold: false },
        { text: 'No', action: () => console.log('Clicked: No') },
        { text: 'Later', action: (toast) => { console.log('Clicked: Later'); this.snotifyService.remove(toast.id); } },
        { text: 'Close', action: (toast) => { console.log('Clicked: Close'); this.snotifyService.remove(toast.id); }, bold: true },
      ]
    });
  }
  onPrompt() {
    const { timeout, closeOnClick, ...config } = this.getConfig();
    this.snotifyService.prompt(this.body, this.title, {
      ...config,
      buttons: [
        { text: 'Yes', action: (toast) => console.log('Said Yes: ' + toast.value) },
        { text: 'No', action: (toast) => { console.log('Said No: ' + toast.value); this.snotifyService.remove(toast.id); } },
      ],
      placeholder: 'Enter "ng-snotify" to validate this input'
    }).on('input', (toast) => {
      toast.valid = !!toast.value.match('ng-snotify');
    });
  }
  onHtml() {
    const html = `<div class="snotifyToast__title"><b>Html Bold Title</b></div>
      <div class="snotifyToast__body"><i>Html</i> <b>toast</b> <u>content</u></div>`;
    this.snotifyService.html(html, this.getConfig());
  }
  onClear() {
    this.snotifyService.clear();
  }
  i: number = 0;
  ngOnInit() {
    this.i = 0;
  }
  ngAfterContentInit() {
    this.sharedService.blockedDocument.emit("ngAfterContentInit: " + this.i++);
  }
  onEvent(block: boolean) {
    this.sharedService.blockedDocument.emit(block);
  }
}
